import Filters from '../abstracts/Filters'
import Logger from '@nematis/js-snippets/assets/js/logging/debug-logger'

export default class EventsManager {
  static dispatchEvent(eventName, ...args) {
    let detail = null
    if (args && args.length) {
      detail = args[0]
    }

    // send custom event
    document.dispatchEvent(new CustomEvent(eventName, detail))

    // send action through global hooks system
    const hookName = eventName.replace('rsq.', '')
    Filters.doAction(hookName, ...args)

    Logger.debug(eventName, args)
  }
}
